import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {isBrowser} from "react-device-detect";

class SurveyLang extends Component {

  constructor(props) {
    super(props);

    if(localStorage.surveyLanguage){
      if(props.languages.indexOf(localStorage.surveyLanguage) === -1){
        localStorage.surveyLanguage = props.defaultLang;
      }
    }

    let l = localStorage.surveyLanguage || props.defaultLang;

    this.state = {
      dropdownOpen: false,
      lang: l
    };
  }

  toggle(){
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  static onChange(lang) {
    localStorage.surveyLanguage = lang;

    if (location.href.indexOf("?") === -1) {
      window.location = location.href += "?lang=" + lang;
    } else {
      let newUrl = new URL(location.href);
      newUrl.searchParams.set('lang', lang); // Adds or replaces the param
      window.location = newUrl.toString();
    }
  }

  render() {
    const {languages} = this.props;
    const {lang, dropdownOpen} = this.state;

    return <Dropdown className={"survey-lang"} isOpen={dropdownOpen} toggle={() => this.toggle()}>
      <DropdownToggle className="m-0 p-0" color="">
        <img src={'/s/img/icon/' + lang +'.png'} />
      </DropdownToggle>
      <DropdownMenu right={!isBrowser}>
        {languages.map(l => {
          return <DropdownItem key={l} onClick={() => SurveyLang.onChange(l)}><img src={'/s/img/icon/' + l +'.png'} /> <FormattedMessage id={'_.lang.' + l + '.text'}/></DropdownItem>
        })}
      </DropdownMenu>
    </Dropdown>;
  }
}

function mapStateToProps(state) {
  return {
    defaultLang: state.surveyResponse.survey.defaultLang,
    languages: state.surveyResponse.survey.languages,
  }
}

export default connect(mapStateToProps)(SurveyLang);